module.exports = __webpack_public_path__ + "img/13.3efb669e.webp";